import { render } from "./prices-table.vue?vue&type=template&id=2955c760&scoped=true"
import script from "./prices-table.vue?vue&type=script&lang=js"
export * from "./prices-table.vue?vue&type=script&lang=js"

import "./prices-table.vue?vue&type=style&index=0&id=2955c760&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2955c760"]])

export default __exports__